var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO: Remove rc-TriggerTooltip usage and make our own system, share styling with persistent-tooltip (or make into one component)
import React from 'react';
import RcTooltip from 'rc-tooltip';
import { createGlobalStyle } from 'styled-components';
import { getReactHtmlObject } from '../html-renderer';
import { body5Styles } from '../typography/style';
var TriggerTooltipStyle = /*#__PURE__*/createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .hippo-trigger-tooltip {\n         position: absolute;\n         z-index: ", ";\n         display: block;\n         max-width: 250px;\n         visibility: visible;\n     }\n    .hippo-trigger-tooltip-hidden {\n         display: none;\n    }\n\n    .hippo-trigger-tooltip-inner {\n         ", ";\n         min-width: 30px;\n         min-height: 32px;\n         text-align: left;\n         text-decoration: none;\n         word-wrap: break-word;\n         border-radius: 8px;\n         box-shadow:  0 4px 2px 0 ", ", 0px 4px 6px 2px ", ";\n         border: 1px solid ", ";\n         padding: 12px 16px 16px 16px;\n         background-color: ", ";\n         color: ", ";\n\n         a {\n             color: ", ";\n         }\n    }\n"])), p => p.theme.zIndex.tooltip, body5Styles, p => p.theme.colors.shadow100, p => p.theme.colors.shadow50, p => p.theme.colors.primary500, p => p.theme.colors.white, p => p.theme.colors.gray600, p => p.theme.colors.gray600);

class TriggerTooltip extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      visible: false
    });

    _defineProperty(this, "onVisibleChange", visible => {
      var {
        onVisibleChange
      } = this.props;
      this.setState({
        visible: visible
      });

      if (onVisibleChange) {
        onVisibleChange(visible);
      }
    });
  }

  render() {
    var {
      overlay,
      dangerouslySetOverlayInnerHTML
    } = this.props;
    var overlayContent = typeof overlay === 'string' && dangerouslySetOverlayInnerHTML ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: getReactHtmlObject(overlay)
    }) : overlay;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TriggerTooltipStyle, null), /*#__PURE__*/React.createElement(RcTooltip, _extends({}, this.props, {
      prefixCls: 'hippo-trigger-tooltip',
      overlay: overlayContent,
      visible: this.state.visible || this.props.forceVisible,
      onVisibleChange: this.onVisibleChange,
      transitionName: 'zoom-big-fast',
      trigger: ['hover']
    })));
  }

}

_defineProperty(TriggerTooltip, "defaultProps", {
  placement: 'top',
  forceVisible: false
});

export default TriggerTooltip;